module.exports = __webpack_public_path__ + "img/tag.d17fd329.svg";